var map = {
	"./dark01": "b36c",
	"./dark01.json": "b36c",
	"./dark02": "60a8",
	"./dark02.json": "60a8",
	"./dark03": "c9e1",
	"./dark03.json": "c9e1",
	"./dark04": "cc57",
	"./dark04.json": "cc57",
	"./dark05": "71f5",
	"./dark05.json": "71f5",
	"./default": "8126",
	"./default.json": "8126",
	"./node": "b102",
	"./node.json": "b102"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bab3";